import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

export interface FeeFilters {
  id?: string;
  client_id?: string;
  user_id?: string;
  coin_front?: string;
  coin_to?: string;
  transaction_type?: string;
  transaction_subtype?: string;
  service_provider?: string;
  provider_id?: string;
  provider_service_id?: string;
}

export interface EffectiveFeeRow {
  id: number | string;
  transaction_type: string | null;
  coin_front: string | null;
  coin_to: string | null;
  cost_fee?: number | string | null;
  user_flat_fee: number | string | null;
  cost_flat_fee?: number | string | null;
  user_fee: number | string | null;
  min_cost?: number | string | null;
  user_min_cost?: number | string | null;
  max_cost?: number | string | null;
  user_max_cost?: number | string | null;
  min_volume?: number | string | null;
  max_volume?: number | string | null;
  transaction_subtype?: string | null;
  provider_service_id?: number | string | null;
  provider_id?: number | string | null;
  service_provider?: string | null;
  billing_mode?: string | null;
}

@Injectable()
export class FeesService {
  constructor(private http: HttpService) {}

  getFees(page = 1, pageSize = 20, filters: FeeFilters = {}) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    Object.entries(filters).forEach(([key, value]) => {
      const normalizedValue = String(value ?? '').trim();
      if (normalizedValue) {
        params = params.set(key, normalizedValue);
      }
    });

    return this.http.get('fees', params).toPromise();
  }

  getEffectiveFees(
    page = 1,
    pageSize = 200,
    filters: FeeFilters = {},
    compact = true,
  ) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', pageSize.toString())
      .set('compact', compact ? 'true' : 'false');

    Object.entries(filters).forEach(([key, value]) => {
      const normalizedValue = String(value ?? '').trim();
      if (normalizedValue) {
        params = params.set(key, normalizedValue);
      }
    });

    return this.http.get('fees/effective', params).toPromise();
  }

  createFee(body: any) {
    return this.http.post('fees', body);
  }

  updateFee(feeId: number | string, body: any) {
    return this.http.put(`fees/${feeId}`, body);
  }

  updateFeeActive(feeId: number | string, active: boolean) {
    return this.http.patch(`fees/${feeId}/active`, { active });
  }

  deleteFee(feeId: number | string) {
    return this.http.delete(`fees/${feeId}`);
  }
}
